var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csp csp-word-text"},[(!_vm.titleHide)?_c('SubHeader',{attrs:{"title":_vm.page.title}}):_vm._e(),_c('div',{ref:"body",staticClass:"body"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }